import { EditorView as t } from "@codemirror/view";
const r = () => t.contentAttributes.of({
  spellcheck: "true"
});
export {
  r as spellcheck
};
//# sourceMappingURL=spellcheck-DIi2vwCn.js.map
